<template>
	<v-card :style="tourIsRunning ? 'pointer-events: none' : ''" height="80vh">
		<v-card-title class="py-2 primary">
			<span class="tertiary--text">{{ getTitle() }}</span>
		</v-card-title>
		<v-card-text class="pa-0">
			<v-progress-linear
				v-if="isLoading"
				indeterminate
			></v-progress-linear>
			<v-form ref="praticaForm">
				<v-tabs
					v-if="!isSettingPratica"
					v-model="activeTab"
					vertical
				>
					<v-tab
						:key="fase.id"
						v-for="fase in fasiWithStati"
						:class="`justify-start text-left ${fase.stepTargetClass} ${setTabTargetClasses(fase.stepTargetClass)}`"
						:style="setTabTargetStyle(fase.stepTargetClass)"
						@click="tourIsRunning ? $tours['guida'].nextStep() : ''"
					>
						<v-badge
							:value="pratica[`ci_sono_aggiornamenti_fase_${fase.ordinamento}`]"
							color="secondary"
							dot
							overlap
							left
						>
							<v-icon left>
								{{ `mdi-numeric-${fase.ordinamento}`}}
							</v-icon>
						</v-badge>
						<div v-html="fase.nome"></div>
					</v-tab>

					<template v-if="bando?.id == 23">
						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<fase-1
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 1)"
										:pratica-diff="praticaDiff"
										:have-files-been-modified="haveFilesBeenModified"
										@update-files="updateFilesFromComponent($event)"
										@is-loading="isLoadingFase1 = $event"
										@update-fase-2-key="fase2key++"
										@update-fase-9-key="fase9key++"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></fase-1>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<fase-2
										:key="fase2key"
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 2)"
										:pratica-diff="praticaDiff"
										:contratto-di-servizio-diff="contrattoDiServizioDiff"
										@update-files="updateFilesFromComponent($event)"
										@is-loading="isLoadingFase2 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></fase-2>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<fase-3
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 3)"
										:pratica-diff="praticaDiff"
										@is-loading="isLoadingFase3 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></fase-3>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<fase-4
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 4)"
										:pratica-diff="praticaDiff"
										@is-loading="isLoadingFase4 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></fase-4>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<fase-5
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 5)"
										:pratica-diff="praticaDiff"
										@is-loading="isLoadingFase5 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></fase-5>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<fase-6
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 6)"
										:pratica-diff="praticaDiff"
										:have-files-been-modified="haveFilesBeenModified"
										@update-files="updateFilesFromComponent($event)"
										@is-loading="isLoadingFase6 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></fase-6>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<fase-7
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 7)"
										:pratica-diff="praticaDiff"
										@update-files="updateFilesFromComponent($event)"
										:have-files-been-modified="haveFilesBeenModified"
										@is-loading="isLoadingFase7 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></fase-7>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<fase-8
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 8)"
										:pratica-diff="praticaDiff"
										@is-loading="isLoadingFase8 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></fase-8>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<fase-9
										:key="fase9key"
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 9)"
										:pratica-diff="praticaDiff"
										:contratto-di-servizio-diff="contrattoDiServizioDiff"
										:have-files-been-modified="haveFilesBeenModified"
										@update-files="updateFilesFromComponent($event)"
										@is-loading="isLoadingFase9= $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></fase-9>
								</v-card-text>
							</v-card>
						</v-tab-item>
					</template>

					<template v-else-if="bando?.id == 25">
						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<bando-25-fase-1
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 1)"
										:pratica-diff="praticaDiff"
										:have-files-been-modified="haveFilesBeenModified"
										@update-files="updateFilesFromComponent($event)"
										@is-loading="isLoadingFase1 = $event"
										@update-fase-2-key="fase2key++"
										@update-fase-6-key="fase6key++"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></bando-25-fase-1>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<bando-25-fase-2
										:key="fase2key"
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 2)"
										:pratica-diff="praticaDiff"
										:contratto-di-servizio-diff="contrattoDiServizioDiff"
										@update-files="updateFilesFromComponent($event)"
										@is-loading="isLoadingFase2 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></bando-25-fase-2>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<bando-25-fase-3
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 3)"
										:pratica-diff="praticaDiff"
										@is-loading="isLoadingFase3 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></bando-25-fase-3>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<bando-25-fase-4
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 4)"
										:pratica-diff="praticaDiff"
										@update-files="updateFilesFromComponent($event)"
										:have-files-been-modified="haveFilesBeenModified"
										@is-loading="isLoadingFase4 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></bando-25-fase-4>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<bando-25-fase-5
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 5)"
										:pratica-diff="praticaDiff"
										@is-loading="isLoadingFase5 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></bando-25-fase-5>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<!-- diventerà fase 6 -->
						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<bando-25-fase-6
										:key="fase6key"
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 6)"
										:pratica-diff="praticaDiff"
										:contratto-di-servizio-diff="contrattoDiServizioDiff"
										:have-files-been-modified="haveFilesBeenModified"
										@update-files="updateFilesFromComponent($event)"
										@is-loading="isLoadingFase6= $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></bando-25-fase-6>
								</v-card-text>
							</v-card>
						</v-tab-item>
					</template>

					<template v-else-if="bando?.id == 33">
						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<bando-33-fase-1
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 1)"
										:pratica-diff="praticaDiff"
										:have-files-been-modified="haveFilesBeenModified"
										@update-files="updateFilesFromComponent($event)"
										@is-loading="isLoadingFase1 = $event"
										@update-fase-2-key="fase2key++"
										@update-fase-5-key="fase5key++"
										@update-fase-6-key="fase6key++"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></bando-33-fase-1>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<!--
										Sincronizzazione file Report tra Fase 2 e Fase 6:
										- :report-file passa files.report dal padre al figlio
										- @report-changed incrementa fase6key per forzare il re-render della Fase 6
										  quando il report viene modificato qui
									-->
									<bando-33-fase-2
										:key="fase2key"
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 2)"
										:pratica-diff="praticaDiff"
										:contratto-di-servizio-diff="contrattoDiServizioDiff"
										:have-files-been-modified="haveFilesBeenModified"
										:report-file="files.report"
										@update-files="updateFilesFromComponent($event)"
										@is-loading="isLoadingFase2 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
										@report-changed="fase6key++"
									></bando-33-fase-2>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<bando-33-fase-3
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 3)"
										:pratica-diff="praticaDiff"
										@is-loading="isLoadingFase3 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></bando-33-fase-3>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<bando-33-fase-4
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 4)"
										:pratica-diff="praticaDiff"
										@update-files="updateFilesFromComponent($event)"
										:have-files-been-modified="haveFilesBeenModified"
										@is-loading="isLoadingFase4 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></bando-33-fase-4>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<bando-33-fase-5
										:key="fase5key"
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 5)"
										:pratica-diff="praticaDiff"
										@is-loading="isLoadingFase5 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></bando-33-fase-5>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<!--
										Sincronizzazione file Report tra Fase 2 e Fase 6:
										- :report-file passa files.report dal padre al figlio
										- @report-changed incrementa fase2key per forzare il re-render della Fase 2
										  quando il report viene modificato qui
									-->
									<bando-33-fase-6
										:key="fase6key"
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 6)"
										:pratica-diff="praticaDiff"
										:contratto-di-servizio-diff="contrattoDiServizioDiff"
										:have-files-been-modified="haveFilesBeenModified"
										:report-file="files.report"
										@update-files="updateFilesFromComponent($event)"
										@is-loading="isLoadingFase6= $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
										@report-changed="fase2key++"
									></bando-33-fase-6>
								</v-card-text>
							</v-card>
						</v-tab-item>
					</template>

					<template v-else-if="bando?.id == 26">
						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<bando-26-fase-1
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 1)"
										:pratica-diff="praticaDiff"
										:have-files-been-modified="haveFilesBeenModified"
										@update-files="updateFilesFromComponent($event)"
										@is-loading="isLoadingFase1 = $event"
										@update-fase-2-key="fase2key++"
										@update-fase-8-key="fase8key++"
										@update-fase-9-key="fase9key++"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></bando-26-fase-1>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<bando-26-fase-2
										:key="fase2key"
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 2)"
										:pratica-diff="praticaDiff"
										:contratto-di-servizio-diff="contrattoDiServizioDiff"
										:have-files-been-modified="haveFilesBeenModified"
										@update-files="updateFilesFromComponent($event)"
										@is-loading="isLoadingFase2 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></bando-26-fase-2>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<bando-26-fase-3
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 3)"
										:pratica-diff="praticaDiff"
										@is-loading="isLoadingFase3 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></bando-26-fase-3>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<bando-26-fase-4
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 4)"
										:pratica-diff="praticaDiff"
										@is-loading="isLoadingFase4 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></bando-26-fase-4>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<bando-26-fase-5
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 5)"
										:pratica-diff="praticaDiff"
										@is-loading="isLoadingFase5 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></bando-26-fase-5>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<bando-26-fase-6
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 6)"
										:pratica-diff="praticaDiff"
										:have-files-been-modified="haveFilesBeenModified"
										@update-files="updateFilesFromComponent($event)"
										@is-loading="isLoadingFase6 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></bando-26-fase-6>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<bando-26-fase-7
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 7)"
										:pratica-diff="praticaDiff"
										@update-files="updateFilesFromComponent($event)"
										:have-files-been-modified="haveFilesBeenModified"
										@is-loading="isLoadingFase7 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></bando-26-fase-7>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<bando-26-fase-8
										:key="fase8key"
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 8)"
										:pratica-diff="praticaDiff"
										@is-loading="isLoadingFase8 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></bando-26-fase-8>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<bando-26-fase-9
										:key="fase9key"
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 9)"
										:pratica-diff="praticaDiff"
										:contratto-di-servizio-diff="contrattoDiServizioDiff"
										:have-files-been-modified="haveFilesBeenModified"
										@update-files="updateFilesFromComponent($event)"
										@is-loading="isLoadingFase9= $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></bando-26-fase-9>
								</v-card-text>
							</v-card>
						</v-tab-item>
					</template>

					<template v-else-if="bando?.id == 28">
						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<bando-28-fase-1
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 1)"
										:pratica-diff="praticaDiff"
										:have-files-been-modified="haveFilesBeenModified"
										@update-files="updateFilesFromComponent($event)"
										@is-loading="isLoadingFase1 = $event"
										@update-fase-2-key="fase2key++"
										@update-fase-5-key="fase5key++"
										@update-fase-6-key="fase6key++"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></bando-28-fase-1>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<bando-28-fase-2
										:key="fase2key"
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 2)"
										:pratica-diff="praticaDiff"
										:contratto-di-servizio-diff="contrattoDiServizioDiff"
										:have-files-been-modified="haveFilesBeenModified"
										@update-files="updateFilesFromComponent($event)"
										@is-loading="isLoadingFase2 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></bando-28-fase-2>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<bando-28-fase-3
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 3)"
										:pratica-diff="praticaDiff"
										@is-loading="isLoadingFase3 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></bando-28-fase-3>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<bando-28-fase-4
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 4)"
										:pratica-diff="praticaDiff"
										@update-files="updateFilesFromComponent($event)"
										:have-files-been-modified="haveFilesBeenModified"
										@is-loading="isLoadingFase4 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></bando-28-fase-4>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<bando-28-fase-5
										:key="fase5key"
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 5)"
										:pratica-diff="praticaDiff"
										@update-files="updateFilesFromComponent($event)"
										:have-files-been-modified="haveFilesBeenModified"
										@is-loading="isLoadingFase5 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></bando-28-fase-5>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<bando-28-fase-6
										:key="fase6key"
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 6)"
										:pratica-diff="praticaDiff"
										:contratto-di-servizio-diff="contrattoDiServizioDiff"
										:have-files-been-modified="haveFilesBeenModified"
										@update-files="updateFilesFromComponent($event)"
										@is-loading="isLoadingFase6= $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></bando-28-fase-6>
								</v-card-text>
							</v-card>
						</v-tab-item>
					</template>

					<template v-else-if="bando?.id == 29">
						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<bando-29-fase-1
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 1)"
										:pratica-diff="praticaDiff"
										:have-files-been-modified="haveFilesBeenModified"
										@update-files="updateFilesFromComponent($event)"
										@is-loading="isLoadingFase1 = $event"
										@update-fase-2-key="fase2key++"
										@update-fase-8-key="fase8key++"
										@update-fase-9-key="fase9key++"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></bando-29-fase-1>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<!--
										Sincronizzazione file Report tra Fase 2 e Fase 9:
										- :report-file passa files.report dal padre al figlio
										- @report-changed incrementa fase9key per forzare il re-render della Fase 9
										  quando il report viene modificato qui
									-->
									<bando-29-fase-2
										:key="fase2key"
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 2)"
										:pratica-diff="praticaDiff"
										:contratto-di-servizio-diff="contrattoDiServizioDiff"
										:have-files-been-modified="haveFilesBeenModified"
										:report-file="files.report"
										@update-files="updateFilesFromComponent($event)"
										@is-loading="isLoadingFase2 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
										@report-changed="fase9key++"
									></bando-29-fase-2>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<bando-29-fase-3
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 3)"
										:pratica-diff="praticaDiff"
										@is-loading="isLoadingFase3 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></bando-29-fase-3>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<bando-29-fase-4
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 4)"
										:pratica-diff="praticaDiff"
										@is-loading="isLoadingFase4 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></bando-29-fase-4>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<bando-29-fase-5
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 5)"
										:pratica-diff="praticaDiff"
										@is-loading="isLoadingFase5 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></bando-29-fase-5>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<bando-29-fase-6
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 6)"
										:pratica-diff="praticaDiff"
										:have-files-been-modified="haveFilesBeenModified"
										@update-files="updateFilesFromComponent($event)"
										@is-loading="isLoadingFase6 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></bando-29-fase-6>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<bando-29-fase-7
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 7)"
										:pratica-diff="praticaDiff"
										@update-files="updateFilesFromComponent($event)"
										:have-files-been-modified="haveFilesBeenModified"
										@is-loading="isLoadingFase7 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></bando-29-fase-7>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<bando-29-fase-8
										:key="fase8key"
										v-model="pratica"  									:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 8)"
										:pratica-diff="praticaDiff"
										@is-loading="isLoadingFase8 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></bando-29-fase-8>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<!--
										Sincronizzazione file Report tra Fase 2 e Fase 9:
										- :report-file passa files.report dal padre al figlio
										- @report-changed incrementa fase2key per forzare il re-render della Fase 2
										  quando il report viene modificato qui
									-->
									<bando-29-fase-9
										:key="fase9key"
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 9)"
										:pratica-diff="praticaDiff"
										:contratto-di-servizio-diff="contrattoDiServizioDiff"
										:have-files-been-modified="haveFilesBeenModified"
										:report-file="files.report"
										@update-files="updateFilesFromComponent($event)"
										@is-loading="isLoadingFase9= $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
										@report-changed="fase2key++"
									></bando-29-fase-9>
								</v-card-text>
							</v-card>
	  					</v-tab-item>
					</template>

					<template v-else-if="bando?.id == 31">
						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<bando-31-fase-1
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 1)"
										:pratica-diff="praticaDiff"
										:have-files-been-modified="haveFilesBeenModified"
										@update-files="updateFilesFromComponent($event)"
										@is-loading="isLoadingFase1 = $event"
										@update-fase-2-key="fase2key++"
										@update-fase-8-key="fase8key++"
										@update-fase-9-key="fase9key++"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									  @dati-estratti-dal-modulo-riepilogo-salvati="$emit('reload-pratiche'); close()"
                    @codice-identificativo-estratto-dal-modulo-codice-clickday-salvato="$emit('reload-pratiche'); close()"
									></bando-31-fase-1>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<!--
										Sincronizzazione file Report tra Fase 2 e Fase 9:
										- :report-file passa files.report dal padre al figlio
										- @report-changed incrementa fase9key per forzare il re-render della Fase 9
										  quando il report viene modificato qui
									-->
									<bando-31-fase-2
										:key="fase2key"
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 2)"
										:pratica-diff="praticaDiff"
										:contratto-di-servizio-diff="contrattoDiServizioDiff"
										:have-files-been-modified="haveFilesBeenModified"
										:report-file="files.report"
										@update-files="updateFilesFromComponent($event)"
										@is-loading="isLoadingFase2 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
										@report-changed="fase9key++"
									></bando-31-fase-2>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<bando-31-fase-3
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 3)"
										:pratica-diff="praticaDiff"
										@is-loading="isLoadingFase3 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></bando-31-fase-3>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<bando-31-fase-4
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 4)"
										:pratica-diff="praticaDiff"
										@is-loading="isLoadingFase4 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></bando-31-fase-4>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<bando-31-fase-5
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 5)"
										:pratica-diff="praticaDiff"
										@is-loading="isLoadingFase5 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></bando-31-fase-5>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<bando-31-fase-6
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 6)"
										:pratica-diff="praticaDiff"
										:have-files-been-modified="haveFilesBeenModified"
										@update-files="updateFilesFromComponent($event)"
										@is-loading="isLoadingFase6 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></bando-31-fase-6>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<bando-31-fase-7
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 7)"
										:pratica-diff="praticaDiff"
										@update-files="updateFilesFromComponent($event)"
										:have-files-been-modified="haveFilesBeenModified"
										@is-loading="isLoadingFase7 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></bando-31-fase-7>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<bando-31-fase-8
										:key="fase8key"
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 8)"
										:pratica-diff="praticaDiff"
										@is-loading="isLoadingFase8 = $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
									></bando-31-fase-8>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item>
							<v-card flat>
								<v-card-text>
									<!--
										Sincronizzazione file Report tra Fase 2 e Fase 9:
										- :report-file passa files.report dal padre al figlio
										- @report-changed incrementa fase2key per forzare il re-render della Fase 2
										  quando il report viene modificato qui
									-->
									<bando-31-fase-9
										:key="fase9key"
										v-model="pratica"
										:action="action"
										:fase-with-stati="fasiWithStati.find(fase => fase.ordinamento == 9)"
										:pratica-diff="praticaDiff"
										:contratto-di-servizio-diff="contrattoDiServizioDiff"
										:have-files-been-modified="haveFilesBeenModified"
										:report-file="files.report"
										@update-files="updateFilesFromComponent($event)"
										@is-loading="isLoadingFase9= $event"
										@aggiornamenti-visualizzati="handleAggiornamentiVisualizzatiEvent($event)"
										@report-changed="fase2key++"
									></bando-31-fase-9>
								</v-card-text>
							</v-card>
						</v-tab-item>
					</template>
				</v-tabs>

				<div v-else class="pa-10 d-flex align-center justify-center">
					<v-progress-circular
						color="primary"
						indeterminate
					></v-progress-circular>
				</div>
			</v-form>
		</v-card-text>
		<v-card-actions>
			<v-btn
				v-if="isAccountManager"
				color="secondary"
				@click="openNotesDialog()"
			>
				Note
			</v-btn>
			<v-btn
				v-if="isAccountManager"
				color="secondary"
				@click="openTagsDialog()"
			>
				Tags
			</v-btn>

			<v-spacer></v-spacer>

			<v-menu
				v-if="isAccountManager && action == 'edit'"
				top
			>
				<template v-slot:activator="{ on, attrs }">
					<v-btn
						:disabled="isSaving"
						color="tertiary"
						class="black--text"
						v-bind="attrs"
						v-on="on"
					>
						Altre opzioni
						<v-icon class="ml-1">
							mdi-arrow-up-drop-circle-outline
						</v-icon>
					</v-btn>
				</template>

				<v-list>
					<v-list-item
						v-if="isAccountManager && action == 'edit' && pratica.modifiche_in_coda !== null"
						@click="openModificheInCodaDialog()"
					>
						<v-list-item-title>
							Modifiche in coda
						</v-list-item-title>
					</v-list-item>

					<v-list-item
						v-if="action == 'edit' && isAccountManager && pratica.ultima_modifica !== null"
						@click="openUltimaModificaDialog()"
					>
						<v-list-item-title>
							Riepilogo modifiche precedenti
						</v-list-item-title>
					</v-list-item>
				</v-list>
			</v-menu>


			<!--<v-btn-->
			<!--	v-if="isAccountManager && action == 'edit' && pratica.modifiche_in_coda !== null"-->
			<!--	@click="openModificheInCodaDialog()"-->
			<!--	:disabled="isSaving"-->
			<!--	color="tertiary"-->
			<!--	class="black&#45;&#45;text"-->
			<!--&gt;-->
			<!--	Modifiche in coda-->
			<!--</v-btn>-->
			<v-btn
				v-if="activeTab === 0 && isAccountManager && action == 'edit'"
				@click="chiudiESegnaComeDaLeggere()"
				:disabled="isSaving"
				:loading="isLoadingChiudiESegnaComeDaLeggere"
				color="tertiary"
				class="black--text"
			>
				Chiudi e segna come da leggere
			</v-btn>
			<!--<v-btn-->
			<!--	v-if="action == 'edit' && isAccountManager && pratica.ultima_modifica !== null"-->
			<!--	@click="openUltimaModificaDialog()"-->
			<!--	:disabled="isSaving"-->
			<!--	color="tertiary"-->
			<!--	class="black&#45;&#45;text"-->
			<!--&gt;-->
			<!--	Riepilogo modifiche precedenti-->
			<!--</v-btn>-->
			<v-btn
				color="tertiary"
				@click="close(); tourIsRunning ? $tours['guida'].nextStep() : ''"
				:disabled="isSaving"
				class="black--text"
				:style="stepTargetName == '.tour-step-29' || 'tour-step-26' ? 'pointer-events: auto' : ''"
			>
				{{ action == 'show' ? 'Chiudi' : (action == 'edit' && changesHaveBeenMade ? 'Annulla' : 'Chiudi')}}
			</v-btn>
			<v-btn
				v-if="(action == 'store' && isAccountManager)
				|| (action == 'edit' && ((isCliente && pratica.id_stato_fase_1 != 2)
				|| (action == 'edit' && (isCoordinatore && pratica.id_stato_fase_6 != 13) || (isCoordinatore && pratica.id_stato_fase_7 != 15))
				|| isAccountManager))"
				:color="!$refs?.praticaForm?.validate() ? 'error' : 'secondary'"
				@click="openSaveDialog()"
				:disabled="isLoading || isSaving || (!changesHaveBeenMade && action == 'edit')"
			>
				<v-icon
					v-if="!$refs?.praticaForm?.validate()"
					class="mr-1"
				>
					mdi-alert-outline
				</v-icon>
				{{ action == 'store' || isCliente ? 'Salva' : 'Riepilogo modifiche' }}
			</v-btn>
		</v-card-actions>

		<v-dialog
			v-model="showSaveDialog"
			persistent
			max-width="700"
			scrollable
		>
			<riepilogo-modifiche
				:pratica="pratica"
				:action="action"
				:praticaDiff="praticaDiff"
				:contrattoDiServizioDiff="contrattoDiServizioDiff"
				:files="files"
				:haveFilesBeenModified="haveFilesBeenModified"
				:isLoading="isLoading"
				:isSaving="isSaving"
				:key="showSaveDialogKey"
				@close="showSaveDialog = false"
				@store="store()"
				@update="update($event)"
			></riepilogo-modifiche>
		</v-dialog>

		<v-dialog
			v-model="notesDialog"
			persistent
			max-width="700"
			scrollable
		>
			<all-notes
				:key="notesKey"
				v-model="praticaForNotes"
				@pratica-notes-updated="
					$emit('pratica-notes-updated', $event);
					praticaForNotes.notes = $event.praticaNotesUpdated"
				@accordo-notes-updated="
					$emit('accordo-notes-updated', $event);
					praticaForNotes.accordo.notes = $event.accordoUpdated.notes"
				@contratto-di-servizio-notes-updated="
					$emit('contratto-di-servizio-notes-updated', $event);
					praticaForNotes.contratto_di_servizio.notes = $event.contrattoDiServizioUpdated.notes"
				@close="notesDialog = false"
			></all-notes>
		</v-dialog>

		<v-dialog
			v-model="tagsDialog"
			persistent
			max-width="700"
			scrollable
		>
			<v-card>
				<v-card-title class="py-2 primary">
					<span class="tertiary--text">Tags</span>
				</v-card-title>
				<v-card-text>
					<v-sheet
						rounded
						color="primary"
						class="my-5 px-4 mt-10 text-h6"
					>
						<span class="tertiary--text">
							Pratica
						</span>
					</v-sheet>
					<store-edit-delete-pratica-tags
						:key="praticaTagsKey"
						:pratica="pratica"
						@is-loading="isLoadingPraticaTags = $event"
						@tags-updated="$emit('pratica-tags-updated', $event)"
					></store-edit-delete-pratica-tags>

					<v-sheet
						rounded
						color="primary"
						class="my-5 px-4 mt-10 text-h6"
					>
						<span class="tertiary--text">
							Contratto di Servizio
						</span>
					</v-sheet>
					<store-edit-delete-contratto-di-servizio-tags
						v-if="pratica.contratto_di_servizio_id !== null"
						:key="contrattoDiServizioTagsKey"
						:contratto-di-servizio="pratica.contratto_di_servizio"
						@is-loading="isLoadingContrattoDiServizioTags = $event"
						@tags-updated="$emit('contratto-di-servizio-tags-updated', $event)"
					></store-edit-delete-contratto-di-servizio-tags>
					<div v-else>Nessun contratto di servizio associato</div>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="tertiary"
						@click="tagsDialog = false"
						:disabled="isLoadingContrattoDiServizioTags || isLoadingPraticaTags"
						class="black--text"
					>
						Chiudi
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog
			v-model="modificheInCodaDialog"
			persistent
			width="unset"
			scrollable
		>
			<modifiche-in-coda
				v-model="pratica"
				:key="modificheInCodaDialogKey"
				@close="modificheInCodaDialog = false;"
				@email-inviata="$emit('reload-pratiche'); close()"
			></modifiche-in-coda>
		</v-dialog>

		<v-dialog
			v-model="ultimaModificaDialog"
			persistent
			width="unset"
			scrollable
		>
			<ultima-modifica
				v-model="pratica"
				:key="ultimaModificaDialogKey"
				@close="ultimaModificaDialog = false;"
				@azione-eseguita="$emit('reload-pratiche'); close()"
			></ultima-modifica>
		</v-dialog>
	</v-card>
</template>

<script>
import {eventBus} from '@/event-bus';
import {mapActions, mapGetters} from "vuex";

export default {
	props: [
		'value',
		'accordo',
		'action',
		'fasiWithStati',
		'activeTabIndex',
		'accordoId', // quando nella pagina Accordi si apre il v-dialog con le pratiche di quell'accordo
		'contrattoDiServizioId' // quando nella pagina Contratti di servizio si apre il v-dialog con le pratiche di quel contratto
	],
	data() {
		return {
			isSettingPratica: true,
			isLoadingFase1: false,
			isLoadingFase2: false,
			isLoadingFase3: false,
			isLoadingFase4: false,
			isLoadingFase5: false,
			isLoadingFase6: false,
			isLoadingFase7: false,
			isLoadingFase8: false,
			isLoadingFase9: false,
			backupPratica: {},
			pratica: {},
			fase2key: 0, // per forzare il rendering
			fase8key: 0, // per forzare il rendering
			fase5key: 0, // per forzare il rendering
			fase6key: 0, // per forzare il rendering
			fase9key: 0, // per forzare il rendering
			files: {
				modulo_codice_clickday: null,
				modulo_riepilogo: null,
				contratto_di_servizio: null,
				screenshot_registrazione: null,
				screenshot_invio: null,
				ricevuta_click_day: null,
				esito_rna: null,
				fattura_acconto: null,
				fattura_saldo: null,
				fattura_acconto_esiti_definitivi: null,
				fattura_saldo_esiti_definitivi: null,
				attestazione_predisposizione_domanda: null,
				modulo_domanda: null,
				report: null
			},
			accordi: [],
			// accordoSelezionato: {},
			aggiornamentiDaApprovare: {
				ci_sono_aggiornamenti_fase_1: false,
				ci_sono_aggiornamenti_fase_2: false,
				ci_sono_aggiornamenti_fase_3: false,
				ci_sono_aggiornamenti_fase_4: false,
				ci_sono_aggiornamenti_fase_5: false,
				ci_sono_aggiornamenti_fase_6: false,
				ci_sono_aggiornamenti_fase_7: false,
				ci_sono_aggiornamenti_fase_8: false,
				ci_sono_aggiornamenti_fase_9: false,
			},

			aggiornamentiPerAccountManager: {
				ci_sono_aggiornamenti_per_account_manager_fase_1: false
			},

			// v-dialog riepilogo-modifiche
			showSaveDialog: false,
			showSaveDialogKey: 0,
			isSaving: false,

			// vue-tour
			activeTab: null,
			vTabsBarContent: null,
			allowedSteps: [
				'tour-step-23',
				'tour-step-24',
				'tour-step-25',
				'tour-step-26',
				'tour-step-27',
				'tour-step-28',
				'tour-step-29',
			],

			// notes
			notesKey: 0,
			notesDialog: false,

			// tags
			tagsDialog: false,
			praticaTagsKey: 0,
			isLoadingPraticaTags: false,
			contrattoDiServizioTagsKey: 0,
			isLoadingContrattoDiServizioTags: false,

			praticaForNotes: null,

			isLoadingChiudiESegnaComeDaLeggere: false,

			modificheInCodaDialogKey: 0,
			modificheInCodaDialog: false,

			ultimaModificaDialogKey: 0,
			ultimaModificaDialog: false
		}
	},

	created() {
		this.getTipiContrattoDiServizio();

		this.isSettingPratica = true;

		this.pratica = JSON.parse(JSON.stringify(this.value || this.praticaVoid));
		this.praticaForNotes = JSON.parse(JSON.stringify(this.value || this.praticaVoid));

		if (this.pratica.contratto_di_servizio === null) {
			this.pratica.contratto_di_servizio = Object.assign({}, this.praticaVoid.contratto_di_servizio);
		}
		if (this.pratica.cliccatore === null) this.pratica.cliccatore = Object.assign({}, this.praticaVoid.cliccatore);
		if (this.action !== 'show') this.$set(this.pratica, 'idPraticaConContrattoDiServizio', null);
		if (this.action == 'edit') this.backupPratica = JSON.parse(JSON.stringify(this.pratica));
		if (this.action == 'store') {
			this.pratica.accordo = this.accordo;
			this.pratica.accordo_id = this.accordo.id;
		}

		if (this.activeTabIndex) this.activeTab = parseInt(JSON.parse(JSON.stringify(this.activeTabIndex))) - 1;
		else this.activeTab = 0;

		this.isSettingPratica = false;

		// salvo la callback in una proprietà così da poterla rimuovere nel beforeDestroy
		this._onSetActiveTab = activeTab => { this.activeTab = activeTab };
		eventBus.$on('set-active-tab', this._onSetActiveTab)

		// eventBus.$on('set-active-tab', activeTab => {
		// 	this.activeTab = activeTab;
		// });
	},

	mounted() {
		this.vTabsBarContent = document.getElementsByClassName('v-tabs-bar__content');
		this.vTabsBarContent[0].classList.add('tour-step-18');
		setTimeout(() => {
			this.$tours['guida'].nextStep();
		}, 500)
	},

	beforeDestroy () {
		eventBus.$off('set-active-tab', this._onSetActiveTab)
	},

	watch: {
		praticaDiff(diff) {
			this.setAggiornamentiPratica();
		},
		contrattoDiServizioDiff(diff) {
			this.setAggiornamentiPratica();
		},
		haveFilesBeenModified(obj) {
			this.setAggiornamentiPratica();
		},
		stepTargetName(target) {
			if (target == '.tour-step-18') this.vTabsBarContent[0].classList.add('v-tour__target--highlighted--inset');
			else this.vTabsBarContent[0].classList.remove('v-tour__target--highlighted--inset');
		},
	},

	computed: {
		...mapGetters({
			isAccountManager: 'auth/isAccountManager',
			isCliente: 'auth/isCliente',
			isCoordinatore: 'auth/isCoordinatore',
			tourIsRunning: 'tour/isRunning',
			strutturaDatiPratica: 'fasi/strutturaDatiPratica',
			bando: 'shared/bando'
		}),
		stepTargetName() {
			if (this.tourIsRunning) return this.$tours['guida'].step.target;
			else return null
		},
		stepTargetNumber() {
			if (this.tourIsRunning) return parseInt(this.$tours['guida'].step.target.match(/\d+/)[0]);
			else return null
		},
		haveFilesBeenModified() {
			let result = {};
			if (this.action == 'edit' && !this.isSettingPratica) {
				for (const key in this.files) {
					if (this.files[key] !== null) {
						result[key] = this.files[key].hasOwnProperty('changed');
					}
					else if (Object.keys(this.pratica).includes(`path_${key}`)) {
						result[key] = this.praticaDiff.includes(`path_${key}`);
					}
					else if (Object.keys(this.pratica.contratto_di_servizio).includes(`path_${key}`)) {
						result[key] = this.contrattoDiServizioDiff.includes(`path_${key}`);
					}
				}
			} else {
				for (const key in this.files) {
					result[key] = false;
				}
			}
			return result;
		},
		praticaDiff() {
			if (!this.isSettingPratica && this.action == 'edit') {
				// escludo le proprietà che non voglio vengano considerate nella funzione getObjectDiff()
				const praticaForObjectDiff = Object.assign({}, this.pratica);
				delete praticaForObjectDiff.notes;
				const backupPraticaForObjectDiff = Object.assign({}, this.backupPratica);
				delete backupPraticaForObjectDiff.notes;

				return this.getObjectDiff(backupPraticaForObjectDiff, praticaForObjectDiff);
				// return this.getObjectDiff(this.backupPratica, this.pratica);
			}
			else return [];
		},
		contrattoDiServizioDiff() {
			if (!this.isSettingPratica && this.action == 'edit') {
				return this.getObjectDiff(this.backupPratica.contratto_di_servizio, this.pratica.contratto_di_servizio);
			}
			else return [];
		},
		changesHaveBeenMade() {
			// escludo le note dal rilevamento delle modifiche
			// && !(this.praticaDiff.length === 1 && this.praticaDiff.includes('notes'))
			return this.praticaDiff.length > 0
				|| this.contrattoDiServizioDiff.length > 0
				|| Object.values(this.haveFilesBeenModified).some(value => value === true);
		},
		isLoading() {
			return this.isSettingPratica
				|| this.isLoadingFase1
				|| this.isLoadingFase2
				|| this.isLoadingFase3
				|| this.isLoadingFase4
				|| this.isLoadingFase5
				|| this.isLoadingFase6
				|| this.isLoadingFase7
				|| this.isLoadingFase8
				|| this.isLoadingFase9;
		},
	},

	methods: {
		...mapActions({
			showSnackbar: 'systemSnackbar/show',
			getTipiContrattoDiServizio: 'contrattoDiServizio/tipiContrattoDiServizio',
		}),
		ciSonoAggiornamentiFase(idFase) {
			// this.$_.pluck è una funzione di vue-underscore che crea un array prendendo i valori delle chiavi 'key'
			const praticaKeys = this.$_.pluck(this.strutturaDatiPratica.fasi[idFase].campi.filter(campo => campo.ref == 'pratica'), 'key');
			const thereAreModificationsInPratica =  this.praticaDiff.filter(value => praticaKeys.includes(value)).length > 0;

			const contrattoDiServizioKeys = this.$_.pluck(this.strutturaDatiPratica.fasi[idFase].campi.filter(campo => campo.ref == 'contratto_di_servizio'), 'key');
			const thereAreModificationsInContrattoDiServizio = this.contrattoDiServizioDiff.filter(value => contrattoDiServizioKeys.includes(value)).length > 0;

			const filesKeys = this.$_.pluck(this.strutturaDatiPratica.fasi[idFase].files, 'key');
			const thereAreModifiedFiles = Object.entries(this.haveFilesBeenModified)
				.filter(([key, value]) => value === true && filesKeys.includes(key))
				.length > 0;

			return thereAreModificationsInPratica || thereAreModificationsInContrattoDiServizio || thereAreModifiedFiles;
		},
		setAggiornamentiPratica() {
			const idsFasi = Object.keys(this.strutturaDatiPratica.fasi);

			idsFasi.forEach(id => {
				if (this.isCliente) this.aggiornamentiPerAccountManager[`ci_sono_aggiornamenti_per_account_manager_fase_${id}`] = this.ciSonoAggiornamentiFase(id); // il Cliente può solo apportare modifiche alla fase 1
				else this.aggiornamentiDaApprovare[`ci_sono_aggiornamenti_fase_${id}`] = this.ciSonoAggiornamentiFase(id);
			})
		},
		setTabTargetStyle(faseStepTargetClass) {
			if (faseStepTargetClass == `tour-step-${this.stepTargetNumber}`) { // target attuale
				return 'pointer-events: none';
			}
			else if (faseStepTargetClass == `tour-step-${this.stepTargetNumber + 1}`) { // target successivo
				return 'pointer-events: auto';
			}
			else if (this.stepTargetName == '.tour-step-18') {
				return 'pointer-events: none';
			}
		},
		setTabTargetClasses(faseStepTargetClass) {
			if ((`.${faseStepTargetClass}` == this.stepTargetName) && this.tourIsRunning) {
				return `v-tour__target--highlighted--inset`
			}
		},
		getTitle() {
			if (this.action == 'store') return 'Nuova Pratica'
			else {
				const titleData = `ID: ${this.pratica.custom_id} - Ragione Sociale Cliente: ${this.pratica.accordo.cliente.ragione_sociale} - Cognome Cliente: ${this.pratica.accordo.cliente.cognome}`
        const contrattoIdTitle = `ID Contratto: ${this.pratica.contratto_di_servizio_id ?? 'Nessun contratto' }`;
				if (this.action == 'edit' && this.isAccountManager) return `Modifica Pratica - ${titleData} - ${contrattoIdTitle}`
				else if (this.action == 'edit' && !this.isAccountManager) return `Pratica ${this.pratica.custom_id}`
				else if (this.action == 'show') return `Visualizza Pratica - ${titleData} - ${contrattoIdTitle}`
			}
		},
		updateFilesFromComponent(files) {
			if (this.action == 'store') {
				for (const key in files) {
					this.files[key] = files[key];
				}
			}
			else if (this.action == 'edit') {
				for (const key in files) {
					if (files[key] !== null) { // se !== null vuol dire che c'è un nuovo file
						if (files[key].hasOwnProperty('changed')) {
							if (files[key].changed) this.files[key] = files[key];
						}
					}
					else this.files[key] = files[key]; // altrimenti si è deciso di cancellare quel file
				}
			}
		},
		openSaveDialog() {
			if (!this.$refs.praticaForm.validate()) return
			this.showSaveDialog = true;
			this.showSaveDialogKey++;
		},
		store() {
			if (!this.$refs.praticaForm.validate()) return
			this.isSaving = true;
			let formData = new FormData();
			for (let key in this.files) {
				formData.append(`files[${key}]`, this.files[key]);
			}
			formData.append('pratica', JSON.stringify(this.pratica));
			axios.post('/api/pratiche', formData, {
				headers: { 'Content-Type': 'multipart/form-data' }
			})
				.then(response => {
					this.showSnackbar({
						color: 'success',
						message: this.generalSuccessMessage
					})
					this.$emit('reload-accordi');
					this.$emit('close');
				})
				.finally(() => {
					this.isSaving = false;
				})
		},
		update(event) {
			if (!this.$refs.praticaForm.validate()) return
			this.isSaving = true;
			let formData = new FormData();

			for (let key in this.files) {
				if (this.files[key] !== null) {
					if (this.files[key].hasOwnProperty('changed')) {
						if (this.files[key].changed) formData.append(`files[${key}]`, this.files[key]);
					}
				}
			}

			// creo una copia di this.pratica perchè i dati inviati saranno differenti dall'originale
			let pratica = Object.assign({}, this.pratica);

			// rimuovo la proprietà per evitare di sovrascrivere nel caso il cliente nel frattempo ha fatto una modifica
			delete pratica.ci_sono_aggiornamenti_per_account_manager_fase_1;

			// se l'account manager ha deciso d'inviare l'email
			if (event.inviaEmailAlCliente || event.inviaEmailAlReferente) {
				for (const key in this.aggiornamentiDaApprovare) {
					if (this.aggiornamentiDaApprovare[key]) pratica[key] = true; // setto a true gli aggiornamenti da leggere
					// rimuovo la proprietà altrimenti se nel frattempo il cliente ha visualizzato gli aggiornamenti portando il valore a false
					// lo riporterei a true perchè nei dati che avevo ricevuto prima questo valore era true
					else delete pratica[key];
				}
			}
			else { // altrimenti elimino tutte le proprietà perchè se il cliente ha visualizzato degli aggiornamenti non posso sovrascrivere con i precedenti valori
				const keys = Object.keys(this.pratica).filter((key) => key.includes('ci_sono_aggiornamenti_fase'));
				keys.forEach(key => {
					delete pratica[key];
				})
			}

			// Faccio sempre l'append di queste modifiche perchè se si è scelto di metterle in coda mi servono per salvarle sul db
			formData.append('listaModificheFasiDaInviarePerEmail', JSON.stringify(event.listaModificheFasiDaInviarePerEmail));

			// Se il Cliente fa modifiche mostro un badge agli account manager
			if (this.isCliente) {
				for (const key in this.aggiornamentiPerAccountManager) {
					if (this.aggiornamentiPerAccountManager[key]) pratica[key] = true;
				}
			}

			// console.log('pratica', pratica);
			// this.isSaving = false;
			// return;

			formData.append('pratica', JSON.stringify(pratica));
			// formData.append('sendEmail', JSON.stringify(this.sendEmail));
			formData.append('invia_email_al_cliente', JSON.stringify(event.inviaEmailAlCliente));
			formData.append('invia_email_al_referente', JSON.stringify(event.inviaEmailAlReferente));
			formData.append('opzione_invio_email', event.opzioneInvioEmail);
			formData.append('thereAreModificationsInContrattoDiServizio', JSON.stringify(this.contrattoDiServizioDiff.length > 0));
			axios.patch(`/api/pratiche/${pratica.id}`, formData, {
				headers: { 'Content-Type': 'multipart/form-data' }
			})
				.then(response => {
					this.showSnackbar({
						color: 'success',
						message: this.generalSuccessMessage
					})
					this.$emit('close');

					// this.$emit('reload-pratiche');

          /**
           * Commentato e sostituito da athis.$emit('reload-pratiche'); in modo da rcaricare tutte le pratiche;
           * questo perchè solo nella funzione index di Laravel si può calcolare la variabile partita_iva_codice_fiscale_univoco
           * essendo un valore che dipende dall'esisitenza o meno di altre pratiche con identico valore di partita_iva_codice_fiscale
           */
					// this.$emit('pratica-updated', {
					// 	praticaId: this.pratica.id,
					// 	callAxios: true
					// });

          this.$emit('reload-pratiche');

					// this.$emit('reload-anteprima-stato-fasi', this.pratica.id);

					if (this.accordoId) {
						this.$emit('reload-accordi');
					}

					if (this.contrattoDiServizioId) {
						this.$emit('reload-contratti-di-servizio');
					}
				})
				.finally(() => {
					this.isSaving = false;
				})
		},
		close() {
			this.$emit('close');
		},
		openNotesDialog() {
			this.notesKey++;
			this.notesDialog = true;
		},
		openTagsDialog() {
			this.praticaTagsKey++;
			this.tagsDialog = true;
		},
		async chiudiESegnaComeDaLeggere() {
			this.isLoadingChiudiESegnaComeDaLeggere = true;
			await this.salvaAggiornamentiDaVisualizzare(this.pratica.id, 'ci_sono_aggiornamenti_per_account_manager_fase_1');

			// this.$emit('reload-pratiche'); // TODO

			this.$emit('pratica-updated', {
				praticaId: this.pratica.id,
				callAxios: true
			});

			this.close();
			this.isLoadingChiudiESegnaComeDaLeggere = false;
		},
		handleAggiornamentiVisualizzatiEvent(event) {
			this.$emit('aggiornamenti-visualizzati', event);
			this.backupPratica[event.aggiornamentoKey] = false;
		},
		openModificheInCodaDialog() {
			this.modificheInCodaDialogKey++;
			this.modificheInCodaDialog = true;
		},
		openUltimaModificaDialog() {
			this.ultimaModificaDialogKey++;
			this.ultimaModificaDialog = true;
		}
	}
}
</script>

<style scoped>

</style>
